import { chakra, Flex, Heading } from "@chakra-ui/react";
import { Messages } from "../../../core/api";
import { POCItemHeader } from "./POCItemHeader";
import { POCItemTaskBody } from "./POCItemTaskBody";

interface POCItemProps {
  item: Messages["PatientDocumentPOCItem"];
  index: number;
  currentAnswer: Messages["POCItemsDocumentAnswer"][] | null;
  isRequired: boolean;
  readonly: boolean;
  onTaskCheck: (name: string) => void;
  onWhenToPerformChange: (name: string, whenToPerform: any) => void;
  onFrequencyChange: (name: string, frequency: number, visitsInAWeek: number) => void;
}

export function POCItem({
  item,
  currentAnswer,
  isRequired,
  readonly,
  onTaskCheck,
  onWhenToPerformChange,
  onFrequencyChange,
}: POCItemProps) {
  if (item.isTitle) {
    return (
      <Heading key={item.name} size="sm" width="full">
        {item.name}
      </Heading>
    );
  }

  const currentItemAnswer = currentAnswer?.find(
    (answer) => answer.item.toLowerCase() === item.name.toLowerCase()
  );
  const isChecked = currentItemAnswer !== undefined;

  return (
    <ItemContainer key={item.name}>
      <POCItemHeader
        isChecked={isChecked}
        isRequired={isRequired}
        item={item}
        readonly={readonly}
        onTaskCheck={onTaskCheck}
      />
      {isChecked && (
        <POCItemTaskBody
          currentAnswer={currentItemAnswer}
          item={item}
          readonly={readonly}
          onFrequencyChange={onFrequencyChange}
          onWhenToPerformChange={onWhenToPerformChange}
        />
      )}
    </ItemContainer>
  );
}

const ItemContainer = chakra(Flex, {
  baseStyle: {
    flex: "40%",
    paddingY: 2,
    paddingX: 4,
    boxShadow: "0px 4px 16px rgba(123, 130, 141, 0.1)",
    borderRadius: "8px",
    flexDirection: "column",
    color: "#283847",
    gap: 2,
  },
});
